class localhostSettings {}

const win: any = window;
if (window.location.href.includes("localhost")) {
    // document.documentElement.lang = win["lang"];
    const lang = window.location.href.includes('localhost') ? 'en' : document.documentElement.lang
    lang === 'ar' ? (document.documentElement.dir = 'rtl') : ''
    const rtl = lang === 'ar'
    !!!win['lang'] && (win['lang'] = lang)
    document.documentElement.lang = lang
    const dir = lang === null || lang === 'en' ? 'ltr' : 'rtl'
    !!!win["googleMapKey"] && (win["googleMapKey"] = import.meta.env.VITE_GMK);
}

export default localhostSettings;
